/* eslint-disable import/no-unresolved */
//no-unresolved issue: https://github.com/nolimits4web/swiper/issues/5058

import { Swiper, SwiperSlide, SwiperProps } from 'swiper/react';
import { Navigation, Lazy } from 'swiper';

import 'swiper/css';
import 'swiper/css/navigation';
import { useDevice } from '@contexts/device';

import { MainWrapper } from './styled';

const Carousel = (props: SwiperProps) => {
  const { isDesktop } = useDevice();

  return (
    <MainWrapper>
      <Swiper
        spaceBetween={12}
        autoplay={false}
        loop={false}
        slidesPerView={1.27}
        navigation={isDesktop}
        preloadImages={false}
        lazy={{
          enabled: true,
        }}
        modules={[Lazy, Navigation]}
        breakpoints={{
          1270: {
            slidesPerView: 4.0,
            spaceBetween: 12,
          },
          1200: {
            slidesPerView: 3.9,
            spaceBetween: 12,
          },
          1180: {
            slidesPerView: 3.6,
            spaceBetween: 12,
          },
          1120: {
            slidesPerView: 3.4,
            spaceBetween: 12,
          },
          1050: {
            slidesPerView: 3.2,
            spaceBetween: 12,
          },
          990: {
            slidesPerView: 3,
            spaceBetween: 12,
          },
          920: {
            slidesPerView: 2.8,
            spaceBetween: 12,
          },
          850: {
            slidesPerView: 2.6,
            spaceBetween: 12,
          },
          700: {
            slidesPerView: 2.4,
            spaceBetween: 12,
          },
          550: {
            slidesPerView: 1.9,
            spaceBetween: 12,
          },
          490: {
            slidesPerView: 1.7,
            spaceBetween: 12,
          },
          450: {
            slidesPerView: 1.5,
            spaceBetween: 12,
          },
          410: {
            slidesPerView: 1.4,
            spaceBetween: 12,
          },
        }}
        {...props}
      />
    </MainWrapper>
  );
};

export { SwiperSlide };
export default Carousel;
